// ── CountUp — число, которое «набегает», как очки в Balatro ──────────────────
// В объёмной теме («Аркада», C.lift) при появлении и при смене значения число бежит
// от прежнего к новому с лёгким перелётом и в конце «подпрыгивает». В остальных темах
// и при «меньше анимации» — сразу итоговое значение. Для экранного диктора — всегда
// итоговое (aria-label), бегущие цифры он не читает.

import { useEffect, useRef, useState } from 'react';
import { usePalette } from './theme';

const easeOutBack = (x) => 1 + 2.2 * (x - 1) ** 3 + 1.2 * (x - 1) ** 2;

export default function CountUp({ value, ms = 650, C: Cp, style }) {
  const C = usePalette(Cp);
  const n = Number(value) || 0;
  const live = !!C.lift && typeof window !== 'undefined' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const [shown, setShown] = useState(live ? 0 : n);
  const from = useRef(live ? 0 : n);
  const [pop, setPop] = useState(0);
  useEffect(() => {
    if (!live) { setShown(n); from.current = n; return undefined; }
    const a = from.current;
    if (a === n) { setShown(n); return undefined; }
    let raf = 0;
    const t0 = performance.now();
    const step = (now) => {
      const x = Math.min(1, (now - t0) / ms);
      setShown(Math.round(a + (n - a) * easeOutBack(x)));
      if (x < 1) raf = requestAnimationFrame(step);
      else { from.current = n; setPop((p) => p + 1); }
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [n, ms, live]);
  return (
    <span aria-label={String(n)} data-num="" data-countup={pop ? '' : undefined} key={pop}
      style={{ display: 'inline-block', fontVariantNumeric: 'tabular-nums', ...style }}>
      <span aria-hidden="true">{shown}</span>
    </span>
  );
}
